import * as React from 'react';
import Moment from 'react-moment';

interface DisplayDateTypes {
	children?: string | number | Date | moment.Moment;
}

export const DisplayDate: React.FC<DisplayDateTypes> = ({ children }) => {
	return (
		<Moment format="DD/MM/YYYY" parse="YYYY-MM-DDTHH:mm:ss.SSSSSSSZ">
			{children}
		</Moment>
	);
};

export default DisplayDate;
